import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ISystemMessageService } from "../ISystemMessageService";
import { Subject, Observable } from "rxjs";
import { Product, Tenor } from "shared/cubiq-model-multi-asset";

export abstract class SystemMessagePromiseService implements ISystemMessageService {
  abstract getSystemMessages(): Observable<CubiqTS.SystemMessage>;
}
